import { render } from "./AddEmail.vue?vue&type=template&id=c460d744"
import script from "./AddEmail.vue?vue&type=script&lang=js"
export * from "./AddEmail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__